/**
 * サービスページ（2026-08）専用スクリプト
 * 出自: 30_coding/assets/js/page-shopify.js
 *
 * 3つの特徴（右カラム）のリビールだけ、共通の custom-202607-top.js より早く発火させる。
 * 共通側は threshold 0.12 / rootMargin -8% で「しっかり入ってから」出すが、
 * この列は1項目が長く、スクロールしても文字が出てこない時間ができる。
 * ここでは画面下端から10%入った時点（threshold 0）で出しはじめる。
 */

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".service-reason__item");

  if (!items.length) {
    return;
  }

  const show = (element) => element.classList.add("is-visible");

  // モーション低減の指定、または監視できない環境では隠さずに出す
  if (
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    !("IntersectionObserver" in window)
  ) {
    items.forEach(show);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        show(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0, rootMargin: "0px 0px -10% 0px" },
  );

  items.forEach((element) => observer.observe(element));

  /* 保険。アンカーでページ途中に着地した場合に、画面より上の項目が
     隠れたまま残らないようにする。 */
  const sweep = () => {
    items.forEach((element) => {
      if (element.classList.contains("is-visible")) {
        return;
      }

      if (element.getBoundingClientRect().top < window.innerHeight) {
        show(element);
        observer.unobserve(element);
      }
    });
  };

  window.addEventListener("load", sweep, { once: true });
});
